require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.fill");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.array.some");

require("core-js/modules/es.array.splice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.global-this");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.number.to-fixed");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-names");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.match");

require("core-js/modules/es.string.repeat");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.split");

require("core-js/modules/es.string.trim");

require("core-js/modules/web.dom-collections.for-each");

var _typeof = require("/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/typeof");

/**
 * ===============================================
 * @tencent/aegis-web-sdk@1.23.39 (c) 2020 ivweb.
 * Author pumpkincai.
 * Released under the MIT License.
 * Thanks for supporting Aegis!
 * ===============================================
 **/
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).Aegis = t();
}(this, function () {
  "use strict";

  var h,
      e,
      a = (t.prototype.indexOf = function (e, t) {
    for (var n = 0; n < e.length; n++) {
      if (e[n].callback === t) return n;
    }

    return -1;
  }, t.prototype.on = function (e, t, n) {
    if (void 0 === n && (n = 0), this) {
      var o = this.__EventsList[e];
      if (o || (this.__EventsList[e] = [], o = this.__EventsList[e]), -1 !== this.indexOf(o, t)) return this;
      var i = {
        name: e,
        type: n || 0,
        callback: t
      };
      return o.push(i), this;
    }
  }, t.prototype.one = function (e, t) {
    this.on(e, t, 1);
  }, t.prototype.remove = function (e, t) {
    if (this) {
      var n,
          o = this.__EventsList[e];
      if (!o) return null;
      if (t) return o.length && (n = this.indexOf(o, t), o.splice(n, 1)), this;

      try {
        delete this.__EventsList[e];
      } catch (e) {}

      return null;
    }
  }, t);

  function t() {
    var s = this;
    this.emit = function (e, t) {
      if (s) {
        var n,
            o = s.__EventsList[e];

        if (null != o && o.length) {
          o = o.slice();

          for (var i = 0; i < o.length; i++) {
            n = o[i];

            try {
              var r = n.callback.apply(s, [t]);
              if (1 === n.type && s.remove(e, n.callback), !1 === r) break;
            } catch (s) {
              throw s;
            }
          }
        }

        return s;
      }
    }, this.__EventsList = {};
  }

  function y(e) {
    return (e = Array.isArray(e) ? e : [e]).map(function (t, n) {
      return Object.getOwnPropertyNames(t).map(function (e) {
        return o(e) + "[" + n + "]=" + o(t[e]);
      }).join("&");
    }).join("&") + (e.length ? "&count=" + e.length : "");
  }

  function o(e) {
    try {
      return encodeURIComponent(decodeURIComponent(e));
    } catch (a) {
      return e;
    }
  }

  function n(e, t) {
    return "number" == typeof e || "string" == typeof e ? e : t ? h.string : h.number;
  }

  function m(e, t) {
    return "string" == typeof e ? e.split("?")[t ? 1 : 0] || "" : e;
  }

  function v(e) {
    return /^https/.test(e);
  }

  function r() {
    return void 0 !== window.performance && "function" == typeof (e = window.Performance) && /native code/.test(e.toString()) && "function" == typeof performance.clearResourceTimings && "function" == typeof performance.getEntriesByType && "function" == typeof performance.now;
    var e;
  }

  (e = h = h || {})[e.number = -1] = "number", e.string = "";
  var i = ["application/octet-stream", "application/xhtml+xml", "application/xml", "application/pdf", "application/pkcs12", "application/javascript", "application/ecmascript", "application/vnd.mspowerpoint", "application/ogg", "text/html", "text/css", "text/javascript", "image", "audio", "video"];

  function w(t) {
    return i.some(function (e) {
      return -1 !== t.indexOf(e);
    });
  }

  var b,
      s,
      u = ["ret", "retcode", "code"],
      _ = function _(e, t) {
    try {
      var n;
      "string" == typeof e && (e = JSON.parse(e)), null != t && t.ret && (n = t.ret, u = (u = [].concat(n)).map(function (e) {
        return e.toLowerCase();
      }));
      var o = Object.getOwnPropertyNames(e).filter(function (e) {
        return -1 !== u.indexOf(e.toLowerCase());
      });
      return o.length ? "" + e[o[0]] : "unknown";
    } catch (e) {
      return "unknown";
    }
  },
      R = function R(e) {
    try {
      return (JSON.stringify(e, (o = [], i = [], function (e, t) {
        if (t instanceof Error) return "Error.message【 " + t.message + " 】;  Error.stack【 " + t.stack + " 】";

        if ("object" == _typeof(t) && null !== t) {
          var n = o.indexOf(t);
          if (-1 !== n) return "[Circular " + i[n] + "]";
          o.push(t), i.push(e || "root");
        }

        return t;
      }), 4) || "undefined").replace(/"/gim, "");
    } catch (e) {
      return "error happen when aegis stringify: \n " + e.message + " \n " + e.stack;
    }

    var o, i;
  },
      d = (Object.defineProperty(l.prototype, "sourceURL", {
    get: function get() {
      return this.data.responseURL;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(l.prototype, "status", {
    get: function get() {
      return Number(this.data.status);
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(l.prototype, "headers", {
    get: function get() {
      var e = this.data.getAllResponseHeaders().split("\n"),
          i = {};
      return e.forEach(function (e) {
        var t, n, o;
        e && (n = (t = e.split(": "))[0], o = t[1].trim(), i[n] = o);
      }), i;
    },
    enumerable: !1,
    configurable: !0
  }), l),
      E = (Object.defineProperty(c.prototype, "sourceURL", {
    get: function get() {
      return this.data.url;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(c.prototype, "status", {
    get: function get() {
      return Number(this.data.status);
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(c.prototype, "headers", {
    get: function get() {
      var n = {};
      return this.data.headers.forEach(function (e, t) {
        n[t] = e;
      }), n;
    },
    enumerable: !1,
    configurable: !0
  }), c);

  function c(e, t) {
    this.type = "fetch", this.data = e || {}, this.data.response = t;
  }

  function l(e) {
    this.type = "xhr", this.data = e;
  }

  function f(n, o) {
    var i,
        r = [];
    return function (e, t) {
      if (r.push(e), o && r.length >= o) return t(r.splice(0, r.length)), void (i && clearTimeout(i));
      i && clearTimeout(i), i = setTimeout(function () {
        i = null, t(r.splice(0, r.length));
      }, n.delay || 1e3);
    };
  }

  (s = b = b || {}).INFO_ALL = "-1", s.API_RESPONSE = "1", s.INFO = "2", s.ERROR = "4", s.PROMISE_ERROR = "8", s.AJAX_ERROR = "16", s.SCRIPT_ERROR = "32", s.IMAGE_ERROR = "64", s.CSS_ERROR = "128", s.CONSOLE_ERROR = "256", s.MEDIA_ERROR = "512", s.RET_ERROR = "1024", s.REPORT = "2048", s.PV = "4096";

  var p = function p(e, t) {
    return Array.isArray(e) ? t(e.map(function (e) {
      return {
        msg: "string" == typeof e.msg ? e.msg : [].concat(e.msg).map(R).join(" "),
        level: e.level
      };
    })) : t({
      msg: "string" == typeof e.msg ? e.msg : R(e.msg),
      level: e.level
    });
  };

  var g = function g() {};

  function O(n) {
    if (!n || !n.reduce || !n.length) throw new TypeError("createPipeline need at least one function param");
    return 1 === n.length ? function (e, t) {
      n[0](e, t || g);
    } : n.reduce(function (n, o) {
      return function (e, t) {
        return void 0 === t && (t = g), n(e, function (e) {
          return null == o ? void 0 : o(e, t);
        });
      };
    });
  }

  var L = (P.use = function (e) {
    -1 === P.installedPlugins.indexOf(e) && e.__aegisPlugin && P.installedPlugins.push(e);
  }, P.prototype.init = function (e) {
    this.setConfig(e);

    for (var t = 0; t < P.installedPlugins.length; t++) {
      try {
        P.installedPlugins[t].patch(this);
      } catch (P) {
        this._sendSDKError(P);
      }
    }

    this.lifeCycle.emit("onInited");
  }, P.prototype.setConfig = function (e) {
    Object.assign(this.config, e);
    var t = this.config,
        n = t.id,
        o = t.uin,
        i = t.version;
    return this.bean.id = n || "", this.bean.uin = o || "", this.bean.version = i || "1.23.39", this.lifeCycle.emit("onConfigChange", e), this.config;
  }, P.prototype.extendBean = function (e, t) {
    this.bean[e] = t;
  }, P.prototype.send = function (e, t, n) {
    throw new Error('You need to override "send" method');
  }, P.prototype._sendSDKError = function (e) {
    this.send({
      url: "https://aegis.qq.com/collect?id=1085&msg[0]=" + encodeURIComponent(R(e)) + "&level[0]=2&from=" + this.config.id + "&count=1&version=" + this.config.id + "(1.23.39)",
      addBean: !1,
      method: "get"
    });
  }, P.prototype._speedLogPipeline = function (e) {
    throw new Error('You need to override "speedLogPipeline" method');
  }, P.prototype.info = function () {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }

    this._normalLogPipeline({
      msg: e,
      level: b.INFO
    });
  }, P.prototype.infoAll = function () {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }

    this._normalLogPipeline({
      msg: e,
      level: b.INFO_ALL
    });
  }, P.prototype.report = function () {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }

    this._normalLogPipeline({
      msg: e,
      level: b.REPORT
    });
  }, P.prototype.reportPv = function (e) {
    var t,
        n = this;
    e && (t = "" + Object.getOwnPropertyNames(this.bean).filter(function (e) {
      return "id" !== e;
    }).map(function (e) {
      return e + "=" + n.bean[e];
    }).join("&"), this.send({
      url: this.config.url + "/" + e + "?" + t,
      addBean: !1
    }));
  }, P.prototype.reportTime = function (e, t) {
    "string" == typeof e ? "number" == typeof t ? this._submitCustomTime(e, t) : console.warn("reportTime: second param must be number") : console.warn("reportTime: first param must be a string");
  }, P.prototype.time = function (e) {
    "string" == typeof e ? this._timeMap[e] ? console.warn("Timer " + e + " already exists") : this._timeMap[e] = Date.now() : console.warn("time: first param must be a string");
  }, P.prototype.timeEnd = function (e) {
    "string" == typeof e ? this._timeMap[e] ? (this._submitCustomTime(e, Date.now() - this._timeMap[e]), delete this._timeMap[e]) : console.warn("Timer " + e + " does not exist") : console.warn("timeEnd: first param must be a string");
  }, P.prototype._submitCustomTime = function (e, t) {
    this._customTimePipeline({
      name: e,
      duration: t
    });
  }, P.LOG_TYPE = b, P.installedPlugins = [], P),
      x = (T.prototype.patch = function (e) {
    this._canUse(e) && this._exist(e) && (this._triggerInit(e), this._instances.push(e), this._triggerOnNewAegis(e));
  }, T.prototype._walk = function (n) {
    var o = this;

    this._instances.forEach(function (e) {
      var t = o._canUse(e);

      t && n(e, t);
    });
  }, T.prototype._canUse = function (e) {
    var t = this._getConfig(e);

    return !(!t || "object" != _typeof(t)) || !!t;
  }, T.prototype._getConfig = function (e) {
    return e.config[this.name];
  }, T.prototype._exist = function (e) {
    return -1 === this._instances.indexOf(e);
  }, T.prototype._triggerInit = function (e) {
    this._inited || (this._inited = !0, this._option.init && this._option.init.call(this._option, this._getConfig(e)));
  }, T.prototype._triggerOnNewAegis = function (e) {
    this._option.onNewAegis && this._option.onNewAegis.call(this._option, e, this._getConfig(e));
  }, T),
      C = new x({
    name: "aid",
    aid: "",
    init: function init() {
      try {
        var e;
        (e = window.localStorage.getItem("AEGIS_ID")) || (e = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
          var t = 16 * Math.random() | 0;
          return ("x" === e ? t : 3 & t | 8).toString(16);
        }), window.localStorage.setItem("AEGIS_ID", e)), this.aid = e;
      } catch (e) {}
    },
    onNewAegis: function onNewAegis(e) {
      e.bean.aid = this.aid;
    }
  }),
      S = (new x({
    name: "reportAssetSpeed"
  }), new x({
    name: "reportAssetSpeed",
    collectCur: 0,
    ASSETS_INITIATOR_TYPE: ["img", "css", "script", "link", "audio", "video"],
    init: function init() {
      var e = this;
      r() && (this.collectSuccLog(), this.collectFailLog(), performance.onresourcetimingbufferfull = function () {
        e.collectCur = 0, performance.clearResourceTimings();
      });
    },
    publish: function publish(t) {
      this.$walk(function (e) {
        e._speedLogPipeline(t);
      });
    },
    collectSuccLog: function collectSuccLog() {
      var i = this,
          n = function n(e) {
        for (var t = 0, n = e.length; t < n; t++) {
          var o = e[t];
          -1 !== i.ASSETS_INITIATOR_TYPE.indexOf(o.initiatorType) && -1 === o.name.indexOf("cdn-go.cn/aegis/aegis-sdk") && i.publish(i.generateLog(o));
        }
      };

      "function" == typeof window.PerformanceObserver ? (n(performance.getEntriesByType("resource")), new window.PerformanceObserver(function (e) {
        n(e.getEntries());
      }).observe({
        entryTypes: ["resource"]
      })) : setInterval(function () {
        var e = performance.getEntriesByType("resource"),
            t = e.slice(i.collectCur);
        i.collectCur = e.length, n(t);
      }, 3e3);
    },
    collectFailLog: function collectFailLog() {
      var i = this;
      window.document.addEventListener("error", function (e) {
        var t, n, o;
        e && e.target && e.srcElement && (n = (t = e.target || e.srcElement).src || t.href) && (o = {
          url: m(n),
          status: 400,
          method: "get",
          type: "static",
          isHttps: v(n),
          urlQuery: m(n, !0),
          x5ContentType: h.string,
          x5HttpStatusCode: h.number,
          x5ImgDecodeStatus: h.number,
          x5ErrorCode: h.number,
          x5LoadFromLocalCache: h.number,
          x5ContentLength: h.number,
          domainLookup: h.number,
          connectTime: h.number
        }, i.publish(o));
      }, !0);
    },
    generateLog: function generateLog(e) {
      return {
        url: m(e.name),
        method: "get",
        duration: Number(e.duration.toFixed(2)),
        status: 200,
        type: "static",
        isHttps: v(e.name),
        urlQuery: m(e.name, !0),
        x5ContentType: n(e.x5ContentType, !0),
        x5HttpStatusCode: n(e.x5HttpStatusCode),
        x5ImgDecodeStatus: n(e.x5ImgDecodeStatus),
        x5ErrorCode: n(e.x5ErrorCode),
        x5LoadFromLocalCache: void 0 === e.x5LoadFromLocalCache ? h.number : 0 | e.x5LoadFromLocalCache,
        x5ContentLength: e.encodedBodySize || n(e.x5ContentLength),
        domainLookup: n(e.domainLookupEnd - e.domainLookupStart),
        connectTime: n(e.connectEnd - e.connectStart)
      };
    }
  })),
      _A = function A(e, t) {
    return (_A = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var n in t) {
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
    })(e, t);
  };

  function T(e) {
    this.__aegisPlugin = !0, this.name = "", this._instances = [], this._inited = !1, e.$walk = this._walk.bind(this), e.$getConfig = this._getConfig.bind(this), this._option = e, this.name = e.name;
  }

  function P(e) {
    var i,
        r,
        t,
        n,
        o,
        s = this;
    this.config = {
      version: 0,
      delay: 1500,
      onError: !0,
      repeat: 5,
      random: 1,
      aid: !0,
      device: !0,
      pagePerformance: !0,
      url: "https://aegis.qq.com/collect",
      speedUrl: "https://aegis.qq.com/speed",
      customTimeUrl: "https://aegis.qq.com/speed/custom",
      whiteListUrl: "https://aegis.qq.com/aegis/whitelist",
      performanceUrl: "https://aegis.qq.com/speed/performance",
      listenOnerror: !0
    }, this.lifeCycle = new a(), this.bean = {}, this._normalLogPipeline = O([f(this.config, 5), p, (t = this.config, n = {}, o = "number" == typeof t.repeat ? t.repeat : 5, function (e, t) {
      t(e.filter(function (e) {
        return e.level !== b.ERROR && e.level !== b.PROMISE_ERROR && e.level !== b.AJAX_ERROR && e.level !== b.SCRIPT_ERROR && e.level !== b.IMAGE_ERROR && e.level !== b.CSS_ERROR && e.level !== b.MEDIA_ERROR || (n[e.msg] = n[e.msg] || 0, !(++n[e.msg] > o));
      }));
    }), (i = this.lifeCycle.emit, r = this.config, function (e, t) {
      var n = r.logCreated;
      if ("function" != typeof n) return i("beforeWrite", e), t(e);
      var o = e.filter(function (e) {
        return !1 !== n(e);
      });
      return i("beforeWrite", o), t(o);
    }), function (e) {
      var o = !1,
          i = !1;
      e.lifeCycle.on("onConfigChange", function () {
        setTimeout(function () {
          e.send({
            url: e.config.whiteListUrl || ""
          }, function (e) {
            i = !0;

            try {
              0 === (e = JSON.parse(e) || {}).retcode && (o = e.result.is_in_white_list);
            } catch (e) {}
          }, function () {
            i = !0;
          });
        }, 50);
      });
      var r = [],
          s = !1;
      return function (e, t) {
        var n;
        !s && e.some(function (e) {
          return e.level === b.ERROR;
        }) && (s = !0), o || s ? t(e.concat(r.splice(0)).map(function (e) {
          return e.level === b.INFO_ALL && (e.level = b.INFO), e;
        })) : (n = e.filter(function (e) {
          return e.level !== b.INFO && e.level !== b.API_RESPONSE ? (e.level === b.INFO_ALL && (e.level = b.INFO), !0) : void (i || (r.push(e), 200 <= r.length && (r.length = 200)));
        })).length && t(n);
      };
    }(this), function (e, t) {
      var n = JSON.parse(JSON.stringify(e));
      s.lifeCycle.emit("beforeReport", n);
      var o = s.config.beforeReport;
      if ("function" == typeof o && (e = e.filter(function (e) {
        return !1 !== o(e);
      })), e.length) return t(e);
    }, function (e) {
      s.send({
        url: s.config.url || "",
        data: y(e),
        method: "post",
        contentType: "application/x-www-form-urlencoded"
      }, function () {
        var t = s.config.onReport;
        "function" == typeof t && e.forEach(function (e) {
          t(e);
        });
      });
    }]), this._timeMap = {}, this._customTimePipeline = O([f(this.config), function (e) {
      s.send({
        url: s.config.customTimeUrl + "?payload=" + encodeURIComponent(JSON.stringify({
          custom: e
        }))
      });
    }]);
  }

  function I(e, t) {
    function n() {
      this.constructor = e;
    }

    _A(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
  }

  var _N = function N() {
    return (_N = Object.assign || function (e) {
      for (var t, n = 1, o = arguments.length; n < o; n++) {
        for (var i in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  new x({
    name: "reportApiSpeed"
  });
  var j,
      k,
      H,
      D,
      U,
      F,
      q = new x({
    name: "reportApiSpeed",
    override: !1,
    onNewAegis: function onNewAegis(e, t) {
      this.override || (this.override = !0, this.overrideFetch(e.config), this.overrideXhr(e.config));
    },
    overrideFetch: function overrideFetch(d) {
      var e, g;
      "function" == typeof window.fetch && (e = window.fetch, g = this, window.fetch = function (l, f) {
        var p = Date.now();
        return e(l, f).then(function (c) {
          try {
            var e,
                t = c.headers ? c.headers.get("content-type") : "";
            c.ok && "string" == typeof t && w(t) ? (e = {
              url: c.url,
              isHttps: v(c.url),
              method: (null == f ? void 0 : f.method) || "get",
              duration: Date.now() - p,
              type: "static",
              status: c.status,
              urlQuery: m(c.url, !0),
              x5ContentType: h.string,
              x5HttpStatusCode: h.number,
              x5ImgDecodeStatus: h.number,
              x5ErrorCode: h.number,
              x5LoadFromLocalCache: h.number,
              x5ContentLength: h.number,
              domainLookup: h.number,
              connectTime: h.number
            }, g.publishSpeed(e)) : c.clone().text().then(function (e) {
              g.publishApiRes({
                msg: l + " " + e,
                level: b.API_RESPONSE
              });

              var t = _(e, d.api),
                  n = {
                url: c.url,
                isHttps: v(c.url),
                method: (null == f ? void 0 : f.method) || "get",
                duration: Date.now() - p,
                type: "fetch",
                ret: t || "unknown",
                status: c.status,
                payload: new E(c, e)
              };

              g.publishSpeed(n);
              var o,
                  i,
                  r,
                  s = (s = d.api && d.api.errCode) && [].concat(s),
                  a = (a = d.api && d.api.code) && [].concat(a),
                  u = d.api && "function" == typeof d.api.retCodeHandler && d.api.retCodeHandler;
              (u ? (i = (o = u(e)).code, r = o.isErr, n.ret = i, r) : s && -1 !== s.indexOf(t) || a && -1 === a.indexOf(t) || !s && !a && "0" !== t && "unknown" !== t) && g.publishApiRes({
                msg: "request url: " + l + " \n response: " + e,
                level: b.RET_ERROR
              });
            });
          } catch (h) {}

          return c;
        })["catch"](function (e) {
          var t = {
            url: l,
            isHttps: v(l),
            method: (null == f ? void 0 : f.method) || "get",
            duration: Date.now() - p,
            type: "fetch",
            status: 600
          };
          throw g.publishSpeed(t), e;
        });
      });
    },
    overrideXhr: function overrideXhr(f) {
      var e = window.XMLHttpRequest.prototype,
          t = e.open,
          n = e.send,
          p = this;
      e.open = function () {
        return this.aegisMethod && this.aegisUrl || (this.aegisMethod = arguments[0], this.aegisUrl = arguments[1]), t.apply(this, arguments);
      }, e.send = function () {
        var c,
            l = Date.now();
        return this.__sendByAegis || this.addEventListener("loadend", function () {
          var e = this.aegisUrl;

          if (e) {
            c = Date.now() - l;
            var t = {
              url: e,
              isHttps: v(e),
              status: this.status,
              method: this.aegisMethod || "get",
              type: "fetch",
              duration: c,
              payload: new d(this)
            },
                n = this.getResponseHeader("content-type");
            if (400 <= this.status || "string" != typeof n || !w(n)) try {
              p.publishApiRes({
                msg: "req url: " + e + " \nres time: " + c + " \nres data: " + this.response,
                level: b.API_RESPONSE
              }), t.ret = _(this.response, f.api);
              var o,
                  i,
                  r,
                  s = (s = f.api && f.api.errCode) && [].concat(s),
                  a = (a = f.api && f.api.code) && [].concat(a),
                  u = f.api && "function" == typeof f.api.retCodeHandler && f.api.retCodeHandler;
              (u ? (i = (o = u(this.response)).code, r = o.isErr, t.ret = i, r) : s && -1 !== s.indexOf(t.ret) || a && -1 === a.indexOf(t.ret) || !s && !a && "0" !== t.ret && "unknown" !== t.ret) && p.publishApiRes({
                msg: "request url: " + e + " \n response: " + this.response,
                level: b.RET_ERROR
              });
            } catch (h) {
              t.ret = "unknown";
            } else t.type = "static", delete t.ret, Object.assign(t, {
              urlQuery: m(e, !0),
              x5ContentType: h.string,
              x5HttpStatusCode: h.number,
              x5ImgDecodeStatus: h.number,
              x5ErrorCode: h.number,
              x5LoadFromLocalCache: h.number,
              x5ContentLength: h.number,
              domainLookup: h.number,
              connectTime: h.number
            });
            p.publishSpeed(t);
          }
        }), n.apply(this, arguments);
      };
    },
    publishSpeed: function publishSpeed(n) {
      var o = this;
      n.url = m(n.url), this.$walk(function (e) {
        var t = o.$getConfig(e);
        "fetch" === n.type && t && "function" == typeof t.urlHandler ? e._speedLogPipeline(_N(_N({}, n), {
          url: encodeURIComponent(t.urlHandler(n.url, n.payload))
        })) : e._speedLogPipeline(n);
      });
    },
    publishApiRes: function publishApiRes(t) {
      this.$walk(function (e) {
        e._normalLogPipeline(t);
      });
    }
  });
  (F = j = j || {})[F.unknown = 100] = "unknown", F[F.wifi = 1] = "wifi", F[F.net2g = 2] = "net2g", F[F.net3g = 3] = "net3g", F[F.net4g = 4] = "net4g", F[F.net5g = 5] = "net5g", F[F.net6g = 6] = "net6g", (U = k = k || {})[U.android = 1] = "android", U[U.ios = 2] = "ios", U[U.other = 100] = "other", (D = H = H || {})[D.oldX5 = 1] = "oldX5", D[D.newX5 = 2] = "newX5", D[D.other = 3] = "other";
  var M = navigator.userAgent,
      X = new x({
    name: "device",
    onNewAegis: function onNewAegis(e) {
      e.config.reportAssetSpeed && (e.extendBean("platform", this.getPlatform()), e.extendBean("x5Type", this.getX5Type()), e.extendBean("netType", j.unknown), this.refreshNetworkTypeToBean(e));
    },
    getPlatform: function getPlatform() {
      var e = k.other;
      return /\bAndroid\s*([^;]+)/.test(M) ? e = k.android : /\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/.test(M) && (e = k.ios), e;
    },
    getX5Type: function getX5Type() {
      var e,
          t = H.other;
      return 0 <= M.toLowerCase().indexOf("tbs") && (t = null != (e = M.match(/tbs\/([\d.]+)/i)) && e[1] && 36541 <= parseInt(e[1], 10) ? H.newX5 : H.oldX5), t;
    },
    refreshNetworkTypeToBean: function refreshNetworkTypeToBean(t) {
      var n = this,
          e = t.config,
          o = B;
      "function" == typeof e.getNetworkType && (o = e.getNetworkType), o(function (e) {
        j[e] || (e = j.unknown), t.extendBean("netType", e), n.NetworkRefreshTimer = setTimeout(function () {
          n.refreshNetworkTypeToBean(t), clearTimeout(n.NetworkRefreshTimer);
        }, 3e3);
      });
    }
  });

  function B(e) {
    var t;
    e((t = navigator.connection && navigator.connection.type ? navigator.connection.type : "unknown", 0 <= (t = String(t).toLowerCase()).indexOf("2g") ? j.net2g : 0 <= t.indexOf("3g") ? j.net3g : 0 <= t.indexOf("4g") ? j.net4g : 0 <= t.indexOf("5g") ? j.net5g : 0 <= t.indexOf("6g") ? j.net6g : 0 <= t.indexOf("wifi") ? j.wifi : j.unknown));
  }

  new x({
    name: "onError"
  });
  var J,
      $ = new x({
    name: "onError",
    init: function init() {
      this.startListen();
    },
    startListen: function startListen() {
      var r = this,
          n = window.onerror;
      window.onerror = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        r.publishErrorLog({
          msg: (e[0] || "") + " @ (" + (e[1] || "") + ":" + (e[2] || 0) + ":" + (e[3] || 0) + ")",
          level: b.ERROR
        }), null == n || n.call.apply(n, function () {
          for (var e = 0, t = 0, n = arguments.length; t < n; t++) {
            e += arguments[t].length;
          }

          for (var o = Array(e), i = 0, t = 0; t < n; t++) {
            for (var r = arguments[t], s = 0, a = r.length; s < a; s++, i++) {
              o[i] = r[s];
            }
          }

          return o;
        }([window], e));
      }, window.addEventListener("unhandledrejection", function (e) {
        var t = e && R(e.reason);
        r.publishErrorLog({
          msg: "PROMISE_ERROR: " + t,
          level: b.PROMISE_ERROR
        });
      }), window.document.addEventListener("error", function (e) {
        if (e && e.target && e.srcElement) {
          var t = e.target || e.srcElement,
              n = t.src || t.href,
              o = t.tagName;

          if (n && -1 === n.indexOf("aegis.qq.com") && o) {
            var i = {
              msg: o + " load fail: " + n,
              level: b.INFO
            };

            switch (o.toLowerCase()) {
              case "script":
                i.level = b.SCRIPT_ERROR;
                break;

              case "link":
                i.level = b.CSS_ERROR;
                break;

              case "audio":
              case "video":
                i.level = b.MEDIA_ERROR;
                break;

              default:
                return;
            }

            r.publishErrorLog(i);
          }
        }
      }, !0);
      var e = window.XMLHttpRequest.prototype,
          t = e.open,
          o = e.send,
          i = this;
      e.open = function () {
        return this.aegisMethod && this.aegisUrl || (this.aegisMethod = arguments[0], this.aegisUrl = arguments[1]), t.apply(this, arguments);
      }, e.send = function () {
        return this.__sendByAegis || this.addEventListener("loadend", function () {
          this.aegisTimeout ? i.publishErrorLog({
            msg: "AJAX_ERROR: request timeout. status: " + this.status + ". \n url: " + this.aegisUrl,
            level: b.AJAX_ERROR
          }) : 0 === this.status ? i.publishErrorLog({
            msg: "AJAX_ERROR: request failed. status: " + this.status + ". \n url: " + this.aegisUrl,
            level: b.AJAX_ERROR
          }) : 400 <= this.status && i.publishErrorLog({
            msg: "AJAX_ERROR: request error. status: " + this.status + ". \n url: " + this.aegisUrl,
            level: b.AJAX_ERROR
          });
        }), this.__sendByAegis || this.addEventListener("timeout", function () {
          this.aegisTimeout = !0;
        }), o.apply(this, arguments);
      };
    },
    publishErrorLog: function publishErrorLog(t) {
      this.$walk(function (e) {
        e._normalLogPipeline(t);
      });
    }
  }),
      V = (new x({
    name: "pagePerformance"
  }), new x({
    name: "pagePerformance",
    onNewAegis: function onNewAegis(o) {
      var i = this;
      if (r()) if (J) this.publish(J, o);else try {
        this.getFirstScreenTiming(function (e) {
          var t = performance.timing,
              n = t.loadEventStart - t.domInteractive;
          n < 0 && (n = 1070), J = {
            dnsLookup: t.domainLookupEnd - t.domainLookupStart,
            tcp: t.connectEnd - t.connectStart,
            ssl: 0 === t.secureConnectionStart ? 0 : t.requestStart - t.secureConnectionStart,
            ttfb: t.responseStart - t.requestStart,
            contentDownload: t.responseEnd - t.responseStart,
            domParse: t.domInteractive - t.domLoading,
            resourceDownload: n,
            firstScreenTiming: Math.floor(e)
          }, i.publish(J, o);
        });
      } catch (o) {}
    },
    publish: function publish(e, t) {
      var n = [];

      for (var o in e) {
        n.push(o + "=" + e[o]);
      }

      var i = this.$getConfig(t),
          r = -1 === t.config.performanceUrl.indexOf("?") ? "?" : "&";
      "function" == typeof i.urlHandler ? t.send({
        url: t.config.performanceUrl + r + n.join("&") + "&from=" + (encodeURIComponent(i.urlHandler()) || window.location.href),
        beanFilter: ["from"]
      }) : t.send({
        url: t.config.performanceUrl + r + n.join("&")
      });
    },
    getFirstScreenTiming: function getFirstScreenTiming(c) {
      var n = ["script", "style", "link", "br"],
          l = [],
          f = this,
          p = new MutationObserver(function (e) {
        var t = {
          roots: [],
          rootsDomNum: [],
          time: performance.now()
        };
        e.forEach(function (e) {
          e && e.addedNodes && e.addedNodes.forEach && e.addedNodes.forEach(function (e) {
            1 !== e.nodeType || -1 !== n.indexOf(e.nodeName.toLocaleLowerCase()) || f.isEleInArray(e, t.roots) || (t.roots.push(e), t.rootsDomNum.push(f.walkAndCount(e) || 0));
          });
        }), t.roots.length && l.push(t);
      });
      p.observe(document, {
        childList: !0,
        subtree: !0
      }), setTimeout(function () {
        p.disconnect();
        var n = 0,
            o = 0,
            i = !1;
        l.forEach(function (e) {
          for (var t = 0; t < e.roots.length; t++) {
            e.rootsDomNum[t] > n && f.isInFirstScreen(e.roots[t]) && (n = e.rootsDomNum[t], o = e.time);
          }
        });

        for (var e, t, r = document.querySelectorAll(".fp-check"), s = [], a = 0; a < r.length; a++) {
          "img" === r[a].tagName.toLowerCase() && "" !== r[a].src ? s.push(r[a].src) : (e = window.getComputedStyle(r[a]), (t = /url\([\'\"](.+)[\'\"]\)/gi.exec(e.backgroundImage)) && 2 === t.length && s.push(t[1]));
        }

        var u = 0;
        window.performance.getEntriesByType("resource").some(function (n) {
          return s.some(function (e, t) {
            if (e === n.name) return n.responseEnd > u && (u = n.responseEnd), (n.fetchStart < o || n.startTime < o) && n.responseEnd > o && (i = !0, o = n.responseEnd), s.splice(t, 1), !0;
          }), 0 === s.length;
        }), 0 === o && (o = u), null == c || c(i ? o : o + 25);
      }, 3e3);
    },
    isEleInArray: function isEleInArray(e, t) {
      return !(!e || e === document.documentElement) && (-1 !== t.indexOf(e) || this.isEleInArray(e.parentElement, t));
    },
    isInFirstScreen: function isInFirstScreen(e) {
      if (!e || !e.getBoundingClientRect) return !1;
      var t = e.getBoundingClientRect(),
          n = window.innerHeight,
          o = window.innerWidth;
      return 0 <= t.left && t.left < o && 0 <= t.top && t.top < n;
    },
    walkAndCount: function walkAndCount(e) {
      var t = 0;

      if (e && 1 === e.nodeType) {
        t++;
        var n = e.children;
        if (null != n && n.length) for (var o = 0; o < n.length; o++) {
          t += this.walkAndCount(n[o]);
        }
      }

      return t;
    }
  })),
      W = (new x({
    name: "tjg"
  }), !1),
      G = new x({
    name: "tjg",
    onNewAegis: function onNewAegis(e) {
      this.setTjgHeader(e);
    },
    setTjgHeader: function setTjgHeader(e) {
      W || (W = !0, this.overrideFetch(e), this.overrideXHR(e));
    },
    overrideFetch: function overrideFetch(n) {
      var o, i;
      "function" == typeof window.fetch && (o = this, i = window.fetch, window.fetch = function (e, t) {
        return o.isSameOrigin(e) && ("object" == _typeof(t) && t ? t.headers ? t.headers instanceof Headers && t.headers.append("X-Tjg-Json-Span-Context", o.getTjgHeaderValue(n)) : t.headers = new Headers({
          "X-Tjg-Json-Span-Context": o.getTjgHeaderValue(n)
        }) : t = {
          headers: new Headers({
            "X-Tjg-Json-Span-Context": o.getTjgHeaderValue(n)
          })
        }), i(e, t);
      });
    },
    overrideXHR: function overrideXHR(e) {
      var t, n, o;
      window.XMLHttpRequest && (t = this, n = window.XMLHttpRequest.prototype.send, o = window.XMLHttpRequest.prototype.open, window.XMLHttpRequest.prototype.open = function () {
        return !this.__sendByAegis && t.isSameOrigin(arguments[1]) && (this.useTjg = !0), o.apply(this, arguments);
      }, window.XMLHttpRequest.prototype.send = function () {
        return this.useTjg && this.setRequestHeader("X-Tjg-Json-Span-Context", t.getTjgHeaderValue(e)), n.apply(this, arguments);
      });
    },
    getTjgHeaderValue: function getTjgHeaderValue(e) {
      return window.btoa && window.btoa(JSON.stringify({
        ids: {
          trace_id: {
            high: this.rand53(),
            low: this.rand53()
          },
          span_id: this.rand53(),
          parent_id: 0,
          flag: 2
        },
        baggages: {
          aegis_session_id: e._sessionID
        }
      }));
    },
    rand53: function rand53() {
      return parseInt(new Array(53).fill(1).map(function () {
        return .5 < Math.random() ? 1 : 0;
      }).join(""), 2);
    },
    isSameOrigin: function isSameOrigin(e) {
      var t = document.createElement("a");
      return t.href = e, location.origin === t.origin;
    }
  });

  function Y(t) {
    if (t.payload) {
      var n = {};
      return Object.keys(t).forEach(function (e) {
        "payload" !== e && (n[e] = t[e]);
      }), n;
    }

    return t;
  }

  Object.assign || Object.defineProperty(Object, "assign", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value(e) {
      if (null == e) throw new TypeError("Cannot convert first argument to object");

      for (var t = Object(e), n = 1; n < arguments.length; n++) {
        var o = arguments[n];

        if (null != o) {
          o = Object(o);

          for (var i = Object.keys(Object(o)), r = 0, s = i.length; r < s; r++) {
            var a = i[r],
                u = Object.getOwnPropertyDescriptor(o, a);
            null != u && u.enumerable && (t[a] = o[a]);
          }
        }
      }

      return t;
    }
  });
  var Q,
      K = 0,
      z = (I(Z, Q = L), Z.useAsyncPlugin = function (s, e) {
    void 0 === e && (e = {});
    var t = e.exportsConstructor,
        a = void 0 === t ? "aegis-plugin-" + K++ : t,
        n = e.onAegisInit,
        u = void 0 === n ? function () {} : n,
        o = e.onAegisInitAndPluginLoaded,
        c = void 0 === o ? function () {} : o;
    if ("string" != typeof s) throw new TypeError("useAsyncPlugin first param must be string");
    if ("function" != typeof u || "function" != typeof c) throw new TypeError("onAegisInit and onAegisInitAndPluginLoaded must be function");
    this.use(new x({
      name: "asyncPlugin",
      onNewAegis: function onNewAegis(n) {
        try {
          u(n), Z._asyncPlugin[s] ? c(n, window[Z._asyncPlugin[s]]) : (e = s, t = a, o = function o(e) {
            var t;
            e || (Z._asyncPlugin[s] = a, t = window[a], c(n, t));
          }, i = document.createElement("script"), r = document.head, "function" == typeof t && (o = t, t = ""), i.src = e, i.setAttribute("name", t), i.name = t, i.async = !0, i.onreadystatechange = function () {
            i.readyState && "loaded" !== i.readyState && "complete" !== i.readyState || ("function" == typeof o && o(!1), setTimeout(function () {
              r.contains(i) && r.removeChild(i);
            }));
          }, i.onload = i.onreadystatechange, i.onerror = function () {
            "function" == typeof o && o(!0), setTimeout(function () {
              r.contains(i) && r.removeChild(i);
            });
          }, r.appendChild(i));
        } catch (Z) {
          console.log("error on below is caused by " + s + "："), console.error(Z);
        }

        var e, t, o, i, r;
      }
    }));
  }, Z.prototype._bean = function (t) {
    var n = this;
    return void 0 === t && (t = []), "" + Object.getOwnPropertyNames(this.bean).filter(function (e) {
      return -1 === t.indexOf(e);
    }).map(function (e) {
      return e + "=" + n.bean[e];
    }).join("&");
  }, Z.prototype.uploadLogs = function (e, t) {
    void 0 === e && (e = {}), void 0 === t && (t = {}), this.lifeCycle.emit("uploadLogs", e, t);
  }, Object.defineProperty(Z, "urls", {
    get: function get() {
      return {
        aegisCollect: "https://aegis.qq.com/collect",
        flog: "https://cdn-go.cn/vasdev/web_webpersistance_v2/latest/flog.core.min.js",
        shadowLog: ""
      };
    },
    enumerable: !1,
    configurable: !0
  }), Z.__version__ = "1.23.39", Z._sessionID = "session-" + Date.now(), Z._asyncPlugin = {}, Z);

  function Z(e) {
    var o,
        i,
        s = Q.call(this, e) || this;
    s._speedLogPipeline = O([(i = {}, function (e, t) {
      var n;
      Array.isArray(e) ? (n = e.filter(function (e) {
        var t = !i[e.url];
        return i[e.url] = !0, t;
      })).length && t(n) : (i[e.url] || t(e), i[e.url] = !0);
    }), f(s.config), (o = s, function (t, n) {
      B(function (e) {
        o.extendBean("netType", e), n(t);
      });
    }), function (e, t) {
      s.lifeCycle.emit("beforeReportSpeed", e);
      var n = s.config.beforeReportSpeed;
      if ("function" == typeof n && (e = e.filter(function (e) {
        var t = !1 !== n(e);
        return "fetch" === e.type && void 0 === e.ret && e.payload && (e.ret = _(e.payload.data.response, s.config.api)), t;
      })), e.length) return t(e);
    }, function (e) {
      var t, n, o, i, r;
      s.send({
        url: "" + s.config.speedUrl,
        method: "post",
        data: (t = e, n = s.bean, i = {
          fetch: [],
          "static": []
        }, r = new FormData(), Array.isArray(t) ? t.forEach(function (e) {
          var t = Y(e);
          i[e.type].push(t);
        }) : (o = Y(t), i[t.type].push(o)), r.append("payload", JSON.stringify(_N({
          duration: i
        }, n))), r)
      });
    }]), s.send = function (e, t, n) {
      var o, i, r;
      e && "string" == typeof e.url && "" !== e.url && s.bean.id && (o = e.url, !1 !== e.addBean && (o = o + (-1 === o.indexOf("?") ? "?" : "&") + s._bean(e.beanFilter)), i = e.method || "get", (r = new XMLHttpRequest()).__sendByAegis = !0, r.addEventListener("readystatechange", function () {
        4 === r.readyState && (400 <= r.status ? null == n || n(r.response) : null == t || t(r.response));
      }), "get" === i.toLocaleLowerCase() ? (r.open("get", function (e, n) {
        if ("string" != typeof e) return "";

        if ("object" == _typeof(n) && n) {
          var t = Object.getOwnPropertyNames(n).map(function (e) {
            var t = n[e];
            return e + "=" + ("string" == typeof t ? encodeURIComponent(t) : encodeURIComponent(JSON.stringify(t)));
          }).join("&").replace(/eval/gi, "evaI");
          return e + (-1 === e.indexOf("?") ? "?" : "&") + t;
        }

        return e;
      }(o, e.data)), r.send()) : (r.open("post", o), e.contentType && r.setRequestHeader("Content-Type", e.contentType), "string" == typeof e.data && (e.data = e.data.replace(/eval/gi, "evaI")), r.send(e.data)));
    }, e.asyncPlugin = !0;

    try {
      e.uin = e.uin || parseInt((document.cookie.match(/\buin=\D+(\d*)/) || [])[1], 10) || parseInt((document.cookie.match(/\bilive_uin=\D*(\d+)/) || [])[1], 10) || "", s.init(e), s.extendBean("sessionId", Z._sessionID), s.extendBean("from", encodeURIComponent(e.pageUrl || location.href)), s.extendBean("referer", document.referrer);
    } catch (Q) {
      console.warn(Q), console.log("%c以上错误发生在初始化 Aegis 的过程中，将会影响您正常使用 Aegis，\n建议您联系 aegis-helper，进行反馈，感谢您的支持。", "color: red"), s._sendSDKError(Q);
    }

    return s;
  }

  new x({
    name: "shadowLog"
  });
  var ee = new x({
    name: "shadowLog",
    onNewAegis: function onNewAegis(e) {
      function n(e) {
        if (u && c) {
          var o = a.id,
              i = a.uin,
              r = z.urls.aegisCollect;

          try {
            var t = (I(n, s = c), n.prototype.init = function (e) {
              var t = {
                dbConfig: {
                  name: e.namespace
                },
                lookupUrl: r + "/shadowLogAuto?id=" + o + "&uin=" + i,
                uploadUrl: r + "/shadowLog",
                preservedDay: 7,
                id: o,
                uin: i,
                sessionId: z._sessionID
              },
                  n = new u(t);
              return this.flog = n, s.prototype.init.call(this, e);
            }, n.prototype.postMessage = function (e) {
              var t = e.type,
                  n = e.data;
              "write" === t && this.flog.add(n);
            }, n.prototype.report = function () {
              this.flog.uploadLogs();
            }, new n(a.shadowLog));
            e.lifeCycle.emit("onShadowLogInit", t);
          } catch (e) {
            console.log(e);
          }
        }

        function n(e) {
          return s.call(this, e) || this;
        }

        var s;
      }

      var t, a, u, c, o;
      t = z.urls.shadowLog, a = e.config, c = u = null, o = a.shadowLog.pluginUrl || t, z.useAsyncPlugin(z.urls.flog, {
        exportsConstructor: "Flog",
        onAegisInitAndPluginLoaded: function onAegisInitAndPluginLoaded(e, t) {
          u = t, n(e);
        }
      }), z.useAsyncPlugin(o, {
        exportsConstructor: "ShadowLogAegisPlugin",
        onAegisInitAndPluginLoaded: function onAegisInitAndPluginLoaded(e, t) {
          c = t, n(e);
        }
      });
    }
  });
  new x({
    name: "offlineLog"
  });
  var te = new x({
    name: "offlineLog",
    onNewAegis: function onNewAegis(e) {
      function p(e) {
        h = h.concat(e);
      }

      function d(e, t) {
        void 0 === e && (e = {}), void 0 === t && (t = {}), m = {
          conds: e,
          params: t
        };
      }

      var t, g, h, m;
      t = z.urls.flog, g = e.config, h = [], m = null, z.useAsyncPlugin(t, {
        exportsConstructor: "Flog",
        onAegisInit: function onAegisInit(e) {
          e.lifeCycle.on("beforeWrite", p), e.lifeCycle.on("uploadLogs", d);
        },
        onAegisInitAndPluginLoaded: function onAegisInitAndPluginLoaded(t, e) {
          var n = g.dbConfig,
              o = void 0 === n ? {} : n,
              i = g.url,
              r = void 0 === i ? z.urls.aegisCollect : i,
              s = g.offlineLogExp,
              a = void 0 === s ? 3 : s,
              u = g.id,
              c = g.uin;
          t.lifeCycle.remove("beforeWrite", p), t.lifeCycle.remove("uploadLogs", d);
          var l = Object.assign({
            lookupUrl: r + "/offlineAuto?id=" + u + "&uin=" + c,
            preservedDay: a,
            id: u,
            uin: c
          }, o, {
            sessionId: z._sessionID
          });

          try {
            var f = new e(l);
            h.forEach(function (e) {
              f.add(_N(_N({}, e), {
                level: b.INFO_ALL ? b.INFO : e.level
              }));
            }), t.lifeCycle.on("beforeWrite", function (e) {
              void 0 === e && (e = []), e.forEach(function (e) {
                f.add(_N(_N({}, e), {
                  level: b.INFO_ALL ? b.INFO : e.level
                }));
              });
            }), t.lifeCycle.on("uploadLogs", function (e, t) {
              void 0 === e && (e = {}), void 0 === t && (t = {});
              var n = Object.assign({
                id: g.id,
                uin: g.uin
              }, e);
              f.uploadLogs(n, t);
            }), t.lifeCycle.on("onConfigChange", function (e) {
              f.setConfig(e);
            }), f.on("PERREVENT", function (e) {
              t.send({
                data: y({
                  msg: R(e),
                  level: b.INFO
                }),
                contentType: "application/x-www-form-urlencoded",
                method: "post",
                addBean: !1,
                url: g.url + "?id=893&sessionId=" + z._sessionID + "&uin=" + g.uin + "&from=" + g.id + "&count=1&version=1.23.39"
              });
            }), m && (t.lifeCycle.emit("uploadLogs", m.conds, m.params), m = null), t.flog = f;
          } catch (t) {
            console.log(t);
          }
        }
      });
    }
  }),
      ne = (new x({
    name: "spa"
  }), new x({
    name: "spa",
    init: function init() {
      history.pushState = this.wr("pushState") || history.pushState, history.replaceState = this.wr("replaceState") || history.replaceState, this.onPageChange();
    },
    onPageChange: function onPageChange() {
      var t = this;
      window.addEventListener("hashchange", function (e) {
        t.sendPv();
      }), window.addEventListener("replaceState", function () {
        t.sendPv();
      }), window.addEventListener("pushState", function () {
        t.sendPv();
      });
    },
    wr: function wr(n) {
      var o = history[n];
      return !("function" != typeof o || !/native code/.test(o.toString())) && function () {
        var e = o.apply(this, arguments),
            t = new Event(n);
        return window.dispatchEvent(t), e;
      };
    },
    sendPv: function sendPv() {
      this.$walk(function (e) {
        e.send({
          url: e.config.whiteListUrl + "?from=" + encodeURIComponent(location.href),
          beanFilter: ["from"]
        });
      });
    }
  }));
  return z.use($), z.use(q), z.use(S), z.use(V), z.use(C), z.use(G), z.use(X), z.use(te), z.use(ee), z.use(ne), z;
});